import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const generateWidgetApiKey = async (domain: string, widgetType: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `widget/create`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        params: { widgetType },
        isEncrypted: true,
    });
}
